import React from "react";
import { useHistory } from "react-router-dom";

import Router from "router/router";
import * as css from "./css/child-panel";

function ChildPanel(props) {
  const { className, childList, onMouseEnter, onMouseLeave, onSelect } = props;

  let history = useHistory();

  function toSearch({
    categoryId,
    optId,
    categoryName,
    categorySelf,
    parentId,
    level,
    isSelect,
  }) {
    onSelect();

    let search = new URLSearchParams();
    if (categoryName) {
      search.append("parentCategoryId", parentId);
      search.append("categoryId", categoryId);
      search.append("categoryOptId", optId);
      search.append("categoryName", categoryName);
      search.append("categorySelf", categorySelf);
      search.append("level", level);
      search.append("isSelect", isSelect);
      search.append("resetCategory", true);
    }
    history.push({
      pathname: Router.Search.path,
      search: search.toString(),
    });
  }

  return (
    <css.ChildPanel
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <css.Container>
        {childList.map((father, i) => {
          const {
            id,
            optId,
            parentId,
            name,
            childList: childListLevel2,
            isSelf,
            hasSelf,
            level,
            isSelect,
          } = father;

          return (
            <css.CategoryFloor key={i}>
              <css.FatherFloor>
                <span
                  className="name"
                  onClick={() => {
                    toSearch({
                      categoryId: id,
                      optId,
                      categoryName: name,
                      categorySelf: isSelf,
                      categoryHasSelf: hasSelf,
                      parentId,
                      level,
                      isSelect,
                    });
                  }}
                >
                  {name}
                </span>
                <img src={require("./img/more.png")} alt="" className="more" />
              </css.FatherFloor>
              {childListLevel2 && (
                <css.ChildrenFloor>
                  {childListLevel2.map((child, j) => {
                    const {
                      id,
                      optId,
                      parentId,
                      name,
                      isSelf,
                      hasSelf,
                      level,
                      isSelect,
                    } = child;

                    return (
                      <span
                        key={j}
                        className="name"
                        onClick={() => {
                          toSearch({
                            categoryId: id,
                            optId,
                            categoryName: name,
                            categorySelf: isSelf,
                            categoryHasSelf: hasSelf,
                            parentId,
                            level,
                            isSelect,
                          });
                        }}
                      >
                        {name}
                      </span>
                    );
                  })}
                </css.ChildrenFloor>
              )}
            </css.CategoryFloor>
          );
        })}
      </css.Container>
    </css.ChildPanel>
  );
}

export default ChildPanel;
